<template>
  <div
    id="email-confirm"
  >
    <div
      class="form-group"
    >
      <button
        type="submit"
        class="btn btn-primary btn-block"
        v-on:click.prevent="confirmEmail"
      >
        Confirm This Email

        <spinner
          size="small"
          v-if="loading"
        />
      </button>
    </div>
  </div>
</template>

<script>
import EmailMixin from '@/mixins/EmailMixin'

import Spinner from 'vue-simple-spinner'

export default {
  props: {
    confirmUserId: {
      type: [ Boolean, Number, String ],
      required: true
    }
  },

  components: {
    'spinner': Spinner
  },

  mixins: [
    EmailMixin
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/EmailConfirm.vue